var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram (4) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5034 4H10.4966C6.91431 4 4 6.91431 4 10.4966V21.5036C4 25.0857 6.91431 28 10.4966 28H21.5036C25.0857 28 28 25.0857 28 21.5036V10.4966C28 6.91431 25.0857 4 21.5034 4ZM26.593 21.5036C26.593 24.3099 24.3099 26.593 21.5034 26.593H10.4966C7.69012 26.593 5.40698 24.3099 5.40698 21.5036V10.4966C5.40698 7.69012 7.69012 5.40698 10.4966 5.40698H21.5036C24.3099 5.40698 26.593 7.69012 26.593 10.4966V21.5036Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9998 9.43774C12.3813 9.43774 9.4375 12.3815 9.4375 16.0001C9.4375 19.6186 12.3813 22.5624 15.9998 22.5624C19.6183 22.5624 22.5621 19.6186 22.5621 16.0001C22.5621 12.3815 19.6183 9.43774 15.9998 9.43774ZM15.9998 21.1554C13.1573 21.1554 10.8445 18.8428 10.8445 16.0001C10.8445 13.1575 13.1573 10.8447 15.9998 10.8447C18.8425 10.8447 21.1552 13.1575 21.1552 16.0001C21.1552 18.8428 18.8425 21.1554 15.9998 21.1554Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.7184 7.10718C21.649 7.10718 20.7793 7.97711 20.7793 9.04626C20.7793 10.1156 21.649 10.9855 22.7184 10.9855C23.7877 10.9855 24.6577 10.1156 24.6577 9.04626C24.6577 7.97693 23.7877 7.10718 22.7184 7.10718ZM22.7184 9.57837C22.425 9.57837 22.1863 9.3396 22.1863 9.04626C22.1863 8.75275 22.425 8.51416 22.7184 8.51416C23.0119 8.51416 23.2507 8.75275 23.2507 9.04626C23.2507 9.3396 23.0119 9.57837 22.7184 9.57837Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/socialInstagram.c318eb56bd337ef98a178a5c4398b9b4.svg";
export { ForwardRef as ReactComponent };